/* Original Renegade — private fulfilment marker for the qualifying Roundup first-order sticker. */
(function(){
'use strict';
var requested=false;
try{requested=new URLSearchParams(window.location.search).get('roundup_reward')==='sticker'}catch(error){}
if(!requested)return;
var config=window.ORTheme||{};
fetch(config.cartUpdateUrl||'/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({attributes:{'__renegade_roundup_reward':'CHECK_FIRST_ORDER_STICKER_ELIGIBILITY'}}),credentials:'same-origin'}).catch(function(){});
})();
